export default "/fcbcac1db17390110677298f9d30eeed9c121039/569373b84d4fa61cda98164451d2ed57.svg";